import { paths } from '@organization/router'
import { LoadingScreen } from '@shared/components'
import { useSessionContext } from '@shared/hooks'
import { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export const AuthGuard = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation()
  const { user: isAuthenticated, isLoading } = useSessionContext()

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!isAuthenticated) {
    return <Navigate to={paths.auth.login} />
  }

  if (pathname === '/') {
    return <Navigate to={paths.applications} replace />
  }

  return children
}
